import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'wika',
} as IModuleProps;
